export const ATTENTIVE_API_ROOT = "https://api.attentivemobile.com/v1";
export const ATTENTIVE_TIMEOUT = Temporal.Duration.from({ seconds: 15 });

// These may need to be updated to represent create, fulfilled, etc.
export enum AttentiveEventType {
  ORDER_TRACKING = "Order Tracking Update",
}

export enum AttentiveIntegrationPurpose {
  SUPPORT = "support",
  MARKETING = "marketing",
}
